import * as React from "react"

type Props = {
  placeholder?: string | undefined,
  name?: string | undefined
  type?: string | undefined
  text?: string | undefined
  value?: string | undefined
  refs?: React.RefObject<HTMLInputElement>;
  setLocation?:() => void;
  onClick?: (e:  React.MouseEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formHandler?: (e: React.FormHTMLAttributes<HTMLFormElement>) => void;
}
const inputText = ({placeholder, name, type, text, value, refs, onChange, onClick,setLocation}: Props) => {
const customValue = () =>{
  return type === "submit" ?  {value: text} : {defaultValue:value === "0" ? "" : value };
}


  return (
    <div>
  
    <input
    onChange={onChange}
    onClick={onClick}
    placeholder={placeholder}
    name={name}
    ref={refs}
    className="border-none bg-white drop-shadow-c-dsh-1 cursor-pointer h-9 min-w-72 text-base text-green-700 px-6  "
    type={type}
    {...customValue()}
    />
</div>
  )
}

export default inputText